import React from 'react';
import { reduxForm } from 'redux-form/immutable';
import * as ReactBootstrap from 'react-bootstrap'
import { connect } from "react-redux";
import { Alert, Button } from 'antd'
import SeeRelation from './TransferStudentForm/SseRelation'
import SseFamilyKind from './TransferStudentForm/SseFamilyKind'
import SseFamilyAir from "./TransferStudentForm/SseFamilyAir";
import SseFarther from "./TransferStudentForm/SseFarther";
import SseMother from "./TransferStudentForm/SseMother";
import SseLiveState from "./TransferStudentForm/SseLiveState";
import SseRichState from "./TransferStudentForm/SseRichState";
import SseS1 from "./TransferStudentForm/SseS1";
import SseS2 from "./TransferStudentForm/SseS2";
import SseS3 from "./TransferStudentForm/SseS3";
import SseS4 from "./TransferStudentForm/SseS4";
import SseS5 from "./TransferStudentForm/SseS5";
import SseS6 from "./TransferStudentForm/SseS6";
import SseS7 from "./TransferStudentForm/SseS7";
import SseS8 from "./TransferStudentForm/SseS8";
import SseS9 from "./TransferStudentForm/SseS9";
import SseS10 from "./TransferStudentForm/SseS10";
import SseS11 from "./TransferStudentForm/SseS11";
import SseQAll from "./TransferStudentForm/SseQAll";
import { fromJS } from 'immutable'

const formFieldsetStyle = {
    border: 0,
    margin: 0,
    padding: 0,
    minWidth: 0,
};

let TransferStudentForm = props => {
    const { handleSubmit, isLocked } = props;
    return (
        <form onSubmit={isLocked ? undefined : handleSubmit} noValidate>
            {isLocked && (
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: '16px' }}
                    message="此表單已由註冊組鎖定，請聯繫註冊組開啟後再修改。"
                />
            )}
            <fieldset disabled={isLocked} style={formFieldsetStyle}>
                <ReactBootstrap.Col md={12}>
                    <h3>家庭狀況</h3>
                    <div className='ml-20'>
                        <SeeRelation />
                        <SseFamilyKind />
                        <SseFamilyAir />
                        <SseFarther />
                        <SseMother />
                        <SseRichState />
                        <SseLiveState />
                    </div>
                    <h3>學習狀況(每項最多填三項)</h3>
                    <div className='ml-20'>
                        <SseS1 />
                        <SseS2 />
                        <SseS3 />
                        <SseS4 />
                        <SseS5 />
                        <SseS6 />
                        <SseS7 />
                        <SseS8 />
                        <SseS9 />
                        <SseS10 />
                        <SseS11 />
                    </div>
                    <h3>為協助我們更了解您的孩子，請告知學生特質，以利老師為孩子做最好的準備！</h3>
                    <div className='ml-20'>
                        <SseQAll />
                    </div>
                </ReactBootstrap.Col>
            </fieldset>
            <Button htmlType="submit" type={'primary'} size={'large'} disabled={isLocked} style={{ width: '100%', marginTop: '10px' }}>
                {isLocked ? '已鎖定' : '送出'}
            </Button>
            <br />
            <br />
            <br />
        </form>
    )
}

TransferStudentForm = reduxForm({
    form: 'editiTransferStudentForm', // a unique identifier for this form
    enableReinitialize: true,
})(TransferStudentForm)

TransferStudentForm = connect(
    state => {
        const data = state.getIn(['TransferStudentReducers', 'data']);
        const safeData = data && data.toJS ? data.toJS() : (data || {});
        return {
            initialValues: fromJS(safeData),
            isLocked: !!safeData.ques_check,
        };
    },
)(TransferStudentForm)
export default TransferStudentForm



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm.jsx